// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"170ba109","239":"647cff40","453":"218854b3","455":"6ddd1db1","521":"0a0314b5","773":"ef26a0b0","977":"d32515ae","979":"a21a15f8"}[chunkId] + ".chunk.js";
};